import React from 'react';
import { motion, AnimatePresence, useDragControls } from 'framer-motion';

// Bottom sheet for the mobile site menu: drag the handle down to close.
export default function MobileMenuSheet({ isOpen, onClose, sheetRef, children, instant }) {
  const controls = useDragControls();

  return (
    <AnimatePresence initial={!instant}>
      {isOpen &&
      <>
          <motion.div
          key="backdrop"
          aria-hidden="true"
          className="fixed inset-0 bg-black/40 z-[65]"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose} />
          <motion.div
          key="sheet"
          ref={sheetRef}
          role="dialog"
          aria-modal="true"
          aria-label="Site menu"
          tabIndex={-1}
          onClick={(e) => e.stopPropagation()}
          className="fixed inset-0 z-[65] bg-white flex flex-col"
          style={{ paddingTop: 'max(env(safe-area-inset-top, 0px), 1.5rem)', paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
          initial={{ y: '100%' }}
          animate={{ y: 0 }}
          exit={{ y: '100%' }}
          transition={{ type: 'spring', damping: 32, stiffness: 320 }}
          drag="y"
          dragControls={controls}
          dragListener={false}
          dragConstraints={{ top: 0, bottom: 0 }}
          dragElastic={{ top: 0, bottom: 0.8 }}
          onDragEnd={(_, info) => {
            if (info.offset.y > 100 || info.velocity.y > 500) onClose();
          }}>
            <div
            className="flex justify-center pt-3 pb-2 cursor-grab touch-none"
            onPointerDown={(e) => controls.start(e)}>
              <span aria-hidden="true" className="w-12 h-1.5 rounded-full bg-gray-300" />
            </div>
            {children}
          </motion.div>
        </>
      }
    </AnimatePresence>);
}